/**
 * TabGroup - Interactive tabbed content component
 * Provides keyboard navigation and ARIA-compliant tab switching.
 */

class TabGroup {
  constructor(container) {
    this.$container = $(container);
    this.$tabs = this.$container.find('.tab-button');
    this.$panels = this.$container.find('.tab-panel');

    this.bindEvents();
  }

  bindEvents() {
    this.$tabs.on('click', (e) => {
      this.activateTab($(e.currentTarget));
    });

    this.$tabs.on('keydown', (e) => {
      const $current = $(e.currentTarget);
      const index = this.$tabs.index($current);
      let targetIndex = null;

      switch (e.key) {
        case 'ArrowRight':
          targetIndex = (index + 1) % this.$tabs.length;
          break;
        case 'ArrowLeft':
          targetIndex = (index - 1 + this.$tabs.length) % this.$tabs.length;
          break;
        case 'Home':
          targetIndex = 0;
          break;
        case 'End':
          targetIndex = this.$tabs.length - 1;
          break;
        default:
          return;
      }

      e.preventDefault();
      const $target = this.$tabs.eq(targetIndex);
      $target.focus();
      this.activateTab($target);
    });
  }

  activateTab($tab) {
    // Deselect all tabs
    this.$tabs
      .attr({ 'aria-selected': 'false', tabindex: '-1' })
      .removeClass('active');

    // Select the clicked tab
    $tab
      .attr({ 'aria-selected': 'true', tabindex: '0' })
      .addClass('active');

    // Hide all panels, show the target
    this.$panels.attr('hidden', '');
    const panelId = $tab.attr('aria-controls');
    $('#' + panelId).removeAttr('hidden');

    // Announce to screen readers
    this.announce($tab.text());
  }

  announce(title) {
    const $announcer = this.$container.find('.sr-announcer');
    $announcer.text(title + ' tab selected');
  }
}

/**
 * Initialize tab groups on the page
 * @param {string} selector - jQuery selector for the container(s)
 */
export function initTabGroup(selector) {
  $(selector).each(function() {
    if ($(this).data('tab-group-initialized')) return;

    const instance = new TabGroup(this);
    $(this).data('tab-group-instance', instance);
    $(this).data('tab-group-initialized', true);
  });
}

export { TabGroup };
